import React, { useEffect, useState } from 'react';
import Graph from '../components/Graph';
import '../styles/App.css';
import { expandNode, getGraphReactions } from '../utility/api';
import NodeInfo from '../components/NodeInfo';
import { loadGraph, save } from '../utility/dataUtility';
import Options from '../components/Options';
import { getNodeChain, panToNodeSmooth } from '../components/graphUtils/graphUtility';
import { useAppContext } from '../utility/AppProvider';
import BackButton from '../components/BackButton';


function MainScreen() {
  
  const { data, setData, onReload, setOnReload, currentSelectedNode, setCurrentSelectedNode, setShowStartScreen, isLoading, setIsLoading , newData, setNewData} = useAppContext();

  const [showNodeInfo, setShowNodeInfo] = useState(false);
  const [panToNode, setPanToNode] = useState(null);
  const [recenterNode, setRecenterNode] = useState(null);
  const [currentlyExpandingNodes, setCurrentlyExpandingNodes] = useState([]);

  useEffect(() => {
    if (!isLoading) {
      save(data);
    }
  }, [isLoading]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const name = urlParams.get('name');
    loadGraph(name, data, setData, setOnReload, setCurrentSelectedNode, () => setShowNodeInfo(true));
  }, []);

  function recenter() {
    var rootNode = data.nodes.find(n => n.group === 0);
    setRecenterNode(rootNode.id);
  }

  function onExpandNode(nodeString) {
    const node = data.nodes.find(n => n.id === nodeString);
    var children = data.nodes.filter(n => n.parent === nodeString);
    // if (children.length > 0) {
    //   children.forEach(element => {
    //     element.isVisible = true;
    //   });

    //   // setNewData(children);
    //   setPanToNode(node);

    //   // set node to not loading
    //   node.isLoading = false;


    //   setData(prevData => ({
    //     ...prevData,
    //     nodes: [...prevData.nodes]
    //   }));
    //   return;
    // }

    var parentString = getNodeChain(nodeString, data);
    var graphName = data.nodes.find(n => n.group === 0).id;
    setIsLoading(true);
    expandNode(parentString, node.group, nodeString, graphName)
      .then(newData => {
        var jsonToReturn = { nodes: newData };
        var newData = jsonToReturn.nodes;

        jsonToReturn.nodes = [...data.nodes, ...jsonToReturn.nodes];
        jsonToReturn.nodes.forEach(element => {
          element.isLoading = false;
        });

        setData(jsonToReturn);
        setIsLoading(false);
      });
  }

 
  const toggleNodeInfo = () => {
    setShowNodeInfo(prevShowNodeInfo => !prevShowNodeInfo);
  }

  useEffect(() => {
    if (!isValidData(data) || !newData) {
      return;
    }
  
    var promises = newData.map(element => {
      return expandNodeAndUpdateData(element);
    });
  
    setNewData(null);
      Promise.all(promises).then(() => {
      save(data);
    })
  }, [newData]);
  
  const isValidData = (data) => {
    return data && data.nodes && data.nodes.length > 0;
  }
  
  const expandNodeAndUpdateData = (element) => {
    const node = data.nodes.find(n => n.id === element.id);
    if (!node) {
      return Promise.resolve();
    }
  
    setNodeExpandingState(node.id, true);
    var graphName = data.nodes.find(n => n.group === 0).id;
  
    return expandNode(getNodeChain(node.id, data), node.group, node.id, graphName)
      .then(newData => {
        setNodeExpandingState(node.id, false);
        handleNewData(newData);
      });
  }
  
  const setNodeExpandingState = (nodeId, isExpanding) => {
    setCurrentlyExpandingNodes(prevNodes => {
      if (isExpanding && !prevNodes.includes(nodeId)) {
        return [...prevNodes, nodeId];
      }
      return prevNodes.filter(n => n !== nodeId);
    });
  }
  
  const handleNewData = (newData) => {
    const combinedData = newData.flat();
    combinedData.forEach(element => {
      element.isVisible = false;
    });
  
    setData(prevData => ({
      ...prevData,
      nodes: [...prevData.nodes, ...combinedData]
    }));
  }
  
  const graphContainerStyle = {
    flex: '10',
    // padding: '20px',
    display: 'flex'
  };

  const width = window.innerWidth;
  const height = window.innerHeight;

  return (
    <div className="App">
       <div className='back-button-div'>
          <BackButton />
        </div>
      <div className='learn-body'>
        <div style={graphContainerStyle}>
          {
            data != null && data.nodes.length > 0 &&
            <Graph graphData={data} onExpandNode={onExpandNode} width={width} height={height} onReload={onReload} setOnReload={setOnReload} setCurrentSelectedNode={setCurrentSelectedNode} currentSelectedNode={currentSelectedNode} panToNode={panToNode} setPanToNode={setPanToNode} currentlyExpandingNodes={currentlyExpandingNodes} recenterNode={recenterNode} setRecenterNode={setRecenterNode} />
          }
        </div>
        {showNodeInfo && <NodeInfo selectedNodeId={currentSelectedNode} selectedNodeChain={getNodeChain(currentSelectedNode, data)} data={data} />}
      </div>
      <Options infoToggle={toggleNodeInfo} recenter={recenter} toggleStartScreen={() => setShowStartScreen(true)} />
    </div>
  );
}

export default MainScreen;